import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ReadMoreText = ({ 
    text, 
    truncatedData = null, 
    charLimit = 200,
    buttonClassName = "text-blue-600 hover:text-blue-800 font-semibold",
    containerClassName = "text-gray-700",
    isHTML = false
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // If truncatedData is provided from API, use it
    if (truncatedData && truncatedData.hasMore) {
        return (
            <div className={containerClassName}>
                <div className="whitespace-pre-wrap">
                    {isHTML ? (
                        <div dangerouslySetInnerHTML={{ __html: isExpanded ? truncatedData.full : truncatedData.preview }} />
                    ) : (
                        <p>{isExpanded ? truncatedData.full : truncatedData.preview}</p>
                    )}
                </div>
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className={`mt-4 flex items-center gap-1 ${buttonClassName}`}
                >
                    {isExpanded ? (
                        <>
                            Read Less <ChevronUp size={16} />
                        </>
                    ) : (
                        <>
                            Read More <ChevronDown size={16} />
                        </>
                    )}
                </button>
            </div>
        );
    }

    // Fallback: truncate on client side if no truncatedData
    if (typeof text !== 'string' || text.length <= charLimit) {
        return (
            <div className={containerClassName}>
                {isHTML ? (
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                ) : (
                    <p className="whitespace-pre-wrap">{text}</p>
                )}
            </div>
        );
    }

    // Truncate and show Read More button
    const truncatedText = text.substring(0, charLimit) + '...';

    return (
        <div className={containerClassName}>
            <div className="whitespace-pre-wrap">
                {isHTML ? (
                    <div dangerouslySetInnerHTML={{ __html: isExpanded ? text : truncatedText }} />
                ) : (
                    <p>{isExpanded ? text : truncatedText}</p>
                )}
            </div>
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className={`mt-4 flex items-center gap-1 ${buttonClassName}`}
            >
                {isExpanded ? (
                    <>
                        Read Less <ChevronUp size={16} />
                    </>
                ) : (
                    <>
                        Read More <ChevronDown size={16} />
                    </>
                )}
            </button>
        </div>
    );
};

export default ReadMoreText;
